import type { LoaderFunction } from 'react-router-dom';
import { LeadCollection } from '@/models/ui/LeadCollection.ts';
import { dealerService } from '@/services/dealerService.ts';
import { leadService } from '@/services/leadService.ts';

export const leadsRouteLoader: LoaderFunction = async () => {
  const validated = dealerService.getSelectedDealerIds();

  const leads = await leadService.getLeads(validated);

  return new LeadCollection(leads.domain.values, 'en-US');
};
